export const RANGE_TYPE = "Range";
export const DAY_AND_TIME_TYPE = "Day & Time";
export const DEFAULT_TIMEZONE = "US/Pacific";
export const DEFAULT_TIMEZONE_ABBR = "PST";
export const RANGE = "Range";
export const DAY_TIME = "Day & Time";

export const EVENT_TYPES = Object.seal(
  Object.freeze({
    LIVESTREAM_SIGNING: "Livestream Signing",
    LIVESTREAM_QA: "Livestream Q&A",
    WATCH_PARTY: "Watch Party",
    CONVENTION: "Convention",
    NON_LIVE_SIGNING: "Non-live Signing",
  }),
);
